/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/allas/components/standalone/AuthorsList/theme';

export const AuthorsListTheme = theme;
